import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface MaintenanceData {
    enabled: boolean;
    message?: { en: string; ar: string };
    title?: { en: string; ar: string };
    scheduledEnd?: string;
    showCountdown?: boolean;
}

export interface MaintenanceApiResponse {
    code: number;
    data: MaintenanceData;
}

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
    // Cache for maintenance data received from interceptor
    private _maintenanceData: MaintenanceData | null = null;

    constructor(private http: HttpClient) {}

    /**
     * Get current maintenance status from API
     */
    getMaintenanceStatus(): Observable<MaintenanceApiResponse> {
        return this.http.get<MaintenanceApiResponse>(
            `${environment.apiUrl}/site/maintenance`
        );
    }

    /**
     * Get/Set cached maintenance data
     * This is set by the interceptor when a 503 response is received
     */
    get maintenanceData(): MaintenanceData | null {
        return this._maintenanceData;
    }

    set maintenanceData(data: MaintenanceData | null) {
        this._maintenanceData = data;
    }

    /**
     * Clear cached maintenance data
     */
    clearMaintenanceData(): void {
        this._maintenanceData = null;
    }
}
